import { GetArtistByIdResponse, GetArtistsResponse } from 'models/artists/ApiModels'
import { ArtistByIdInfo, Artists } from 'models/artists/EntityModels'

export const deserializeArtists = (data: GetArtistsResponse): Artists => {
  return {
    count: data.count || 0,
    items: data.items.map(item => ({
      id: item.id || 0,
      name: item.name || '',
      photo: item.photo || '',
      country: item.country || '',
      city: item.city || '',
      slug: item.slug || ''
    }))
  }
}

export const deserializeArtist = (data: GetArtistByIdResponse): ArtistByIdInfo => {
  return {
    id: data.id,
    name: data.name,
    description: data.description,
    country: data.country,
    city: data.city,
    facebookUrl: data.facebook_url,
    instagramUrl: data.instagram_url,
    youtubeUrl: data.youtube_url,
    vkontakteUrl: data.vkontakte_url,
    tiktokUrl: data.tiktok_url,
    twitterUrl: data.twitter_url,
    rutubeUrl: data.rutube_url,
    telegramUrl: data.telegram_url,
    maxUrl: data.max_url,
    musicVkontakteUrl: data.music_vkontakte_url,
    musicSpotifyUrl: data.music_spotify_url,
    musicSoundcloudUrl: data.music_soundcloud_url,
    musicYandexUrl: data.music_yandex_url,
    playlistCode: data.playlist_code,
    projectName: data.project_name,
    projectDescription: data.project_description,
    photoSite: data.photo_site,
    confirmed: data.confirmed,
    slug: data.slug,
    genre: data.genre
  }
}
